/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetPushToStartLiveActivityTokenRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {SetPushToStartLiveActivityTokenResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const setPushToStartLiveActivityToken = (request: SetPushToStartLiveActivityTokenRequest, options?: CashRequestOptions) => post<SetPushToStartLiveActivityTokenRequest, SetPushToStartLiveActivityTokenResponse>("/2.0/cash/set-push-to-start-live-activity-token", request, {...options, rejectOnError: true })